import { render, staticRenderFns } from "./BaseInputDate.vue?vue&type=template&id=4675abf1&scoped=true&"
import script from "./BaseInputDate.vue?vue&type=script&lang=js&"
export * from "./BaseInputDate.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputDate.vue?vue&type=style&index=0&id=4675abf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675abf1",
  null
  
)

export default component.exports